import { useMediaQuery } from '@abyss/web/hooks/useMediaQuery';
import { Drawer } from '@abyss/web/ui/Drawer';
import { Heading } from '@abyss/web/ui/Heading';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { AreaOfExpertiseDetails } from '../../../../models/ProviderDetails';
import {
  phoneOnly,
  recentActivityDrawerDesktop,
  recentActivityDrawerMobile,
} from '../../../ConstantsStyles';
import { AoeDescriptionContent } from './AoeDescriptionContent';

type Props = {
  areaOfExpertiseDetails?: AreaOfExpertiseDetails[];
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
};

export const AoeDrawer = ({
  areaOfExpertiseDetails,
  isOpen,
  setIsOpen,
}: Props) => {
  const { t } = useTranslation();
  const mobileScreen = useMediaQuery(phoneOnly);

  return (
    <Drawer
      css={
        mobileScreen ? recentActivityDrawerMobile : recentActivityDrawerDesktop
      }
      data-testid="drawer-aoe-description"
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      position={mobileScreen ? 'bottom' : 'right'}
      size={mobileScreen ? window.innerHeight - 104 : 408}
      title={
        <Heading
          color="#002677"
          data-auto-testid="aoe-drawer-heading"
          data-testid="aoe-drawer-heading"
          offset={3}
        >
          {t('PROVIDER_DETAILS.ABOUT_TAB.DETAILS_SECTION.AREAS_OF_EXPERTISE')}
        </Heading>
      }
    >
      <Drawer.Section onClick={(e: React.MouseEvent) => e.stopPropagation()}>
        <AoeDescriptionContent
          areaOfExpertiseDetails={areaOfExpertiseDetails}
        />
      </Drawer.Section>
    </Drawer>
  );
};
